<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M20 16.25V15H18.6869C18.6058 14.6089 18.4505 14.237 18.2294 13.9044L19.1606 12.9731L18.2769 12.0894L17.3456 13.0206C17.013 12.7995 16.6411 12.6442 16.25 12.5631V11.25H15V12.5631C14.6089 12.6442 14.237 12.7995 13.9044 13.0206L12.9731 12.0894L12.0894 12.9731L13.0206 13.9044C12.7995 14.237 12.6442 14.6089 12.5631 15H11.25V16.25H12.5631C12.6444 16.6481 12.8031 17.0181 13.0206 17.3456L12.0894 18.2769L12.9731 19.1606L13.9044 18.2294C14.237 18.4505 14.6089 18.6058 15 18.6869V20H16.25V18.6869C16.6411 18.6058 17.013 18.4505 17.3456 18.2294L18.2769 19.1606L19.1606 18.2769L18.2294 17.3456C18.4505 17.013 18.6058 16.6411 18.6869 16.25H20ZM15.625 17.5C14.5913 17.5 13.75 16.6587 13.75 15.625C13.75 14.5913 14.5913 13.75 15.625 13.75C16.6587 13.75 17.5 14.5913 17.5 15.625C17.5 16.6587 16.6587 17.5 15.625 17.5ZM12.5 10.625H7.5C7.16848 10.625 6.85054 10.4933 6.61612 10.2589C6.3817 10.0245 6.25 9.70652 6.25 9.375V2.5C6.25 2.16848 6.3817 1.85054 6.61612 1.61612C6.85054 1.3817 7.16848 1.25 7.5 1.25H12.5C12.8315 1.25 13.1495 1.3817 13.3839 1.61612C13.6183 1.85054 13.75 2.16848 13.75 2.5V9.375C13.75 9.70652 13.6183 10.0245 13.3839 10.2589C13.1495 10.4933 12.8315 10.625 12.5 10.625ZM7.5 9.375H12.5V2.5H7.5V9.375Z"
      :class="containerClass"
    />
    <path d="M10.625 13.125H5C4.66848 13.125 4.35054 12.9933 4.11612 12.7589C3.8817 12.5245 3.75 12.2065 3.75 11.875V4.375H5V11.875H10.625V13.125Z" :class="containerClass" />
    <path d="M8.125 15.625H2.5C1.81062 15.625 1.25 15.0644 1.25 14.375V6.875H2.5V14.375H8.125V15.625Z" :class="containerClass" />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
